import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { PrivateRoute } from '@/hooks/useAuth';

const FinancialAccountsPage = lazy(() => import('@/containers/Views/Financial/FinancialAccountsPage'));
const FinancialAccountCreatePage = lazy(() => import('@/containers/Views/Financial/FinancialAccountCreatePage'));
const FinancialAccountEditPage = lazy(() => import('@/containers/Views/Financial/FinancialAccountEditPage'));
const FinancialAccountDetailPage = lazy(() => import('@/containers/Views/Financial/FinancialAccountDetailPage'));
const FinancialMovementsPage = lazy(() => import('@/containers/Views/Financial/FinancialMovementsPage'));
const FinancialMovementDetailPage = lazy(() => import('@/containers/Views/Financial/FinancialMovementDetailPage'));

const FinancialRouter = (
  <>
    <Route path="financial_accounts">
      <Route
        index
        element={(
          <PrivateRoute
            pageName={EPage.FinancialAccounts}
            permissions={EBasicActions.Find}
          >
            <FinancialAccountsPage />
          </PrivateRoute>
        )}
      />
      <Route
        path="new"
        element={(
          <PrivateRoute
            pageName={EPage.FinancialAccounts}
            permissions={EBasicActions.Find}
          >
            <FinancialAccountCreatePage />
          </PrivateRoute>
        )}
      />
      <Route
        path=":financialAccountId"
        element={(
          <PrivateRoute
            pageName={EPage.FinancialAccounts}
            permissions={EBasicActions.Find}
          >
            <FinancialAccountDetailPage />
          </PrivateRoute>
        )}
      />
      <Route
        path=":financialAccountId/edit"
        element={(
          <PrivateRoute
            pageName={EPage.FinancialAccounts}
            permissions={EBasicActions.Find}
          >
            <FinancialAccountEditPage />
          </PrivateRoute>
        )}
      />
    </Route>

    <Route path="financial_movements">
      <Route
        index
        element={(
          <PrivateRoute
            pageName={EPage.FinancialMovements}
            permissions={EBasicActions.Find}
          >
            <FinancialMovementsPage />
          </PrivateRoute>
        )}
      />
      <Route
        path=":financialMovementId"
        element={(
          <PrivateRoute
            pageName={EPage.FinancialMovements}
            permissions={EBasicActions.Find}
          >
            <FinancialMovementDetailPage />
          </PrivateRoute>
        )}
      />
    </Route>
  </>
);

export default FinancialRouter;
